import { IPackProps } from "../types";
import Logo from "../../assets/img/logo.jpg";

export { Logo };

export const Colors = {
  McDonaldRed: "#FF0000",
  McDonaldRedDark: "#CC0000",
  McDonaldRedLight: "#FF4444",
  KFCRed: "#E31837",
  KFCRedDark: "#B31414",
  KFCRedLight: "#FF1A1A",
  Cream: "#F5F5DC",
  WarmWhite: "#FEFEFE",
  Charcoal: "#36454F",
  Gold: "#DAA520",
};

export const AppName = "Uncle Stans Foods";

export const Packs: IPackProps[] = [
  {
    id: "economy",
    name: "Economy",
    price: 2000,
    items: [
      { name: "SPRING ROLL", count: 1 },
      { name: "SAMOSA", count: 1 },
      { name: "GIZZARD", count: 1 },
      { name: "PUFF PUFF", count: 4 },
      { name: "MOSA", count: 4 },
    ],
  },
  {
    id: "starter-pack",
    name: "Starter Pack",
    price: 2500,
    items: [
      { name: "SPRING ROLL", count: 1 },
      { name: "SAMOSA", count: 1 },
      { name: "BBQ CHICKEN", count: 1 },
      { name: "PUFF PUFF", count: 4 },
      { name: "MOSA", count: 4 },
    ],
  },
  {
    id: "classic-pack",
    name: "Classic Pack",
    price: 3000,
    items: [
      { name: "SPRING ROLL", count: 1 },
      { name: "SAMOSA", count: 1 },
      { name: "BBQ CHICKEN", count: 1 },
      { name: "GIZZARD", count: 1 },
      { name: "PUFF PUFF", count: 4 },
      { name: "MOSA", count: 4 },
    ],
  },
  {
    id: "something-fishy-pack",
    name: "Something Fishy Pack",
    price: 3500,
    items: [
      { name: "SPRING ROLL", count: 1 },
      { name: "SAMOSA", count: 1 },
      { name: "BBQ CHICKEN", count: 1 },
      { name: "GIZZARD", count: 1 },
      { name: "FISH FINGER", count: 1 },
      { name: "PUFF PUFF", count: 4 },
      { name: "MOSA", count: 4 },
    ],
  },
  {
    id: "premium-pack",
    name: "Premium Pack",
    price: 4500,
    items: [
      { name: "SPRING ROLL", count: 1 },
      { name: "SAMOSA", count: 1 },
      { name: "BBQ CHICKEN", count: 1 },
      { name: "GIZZARD", count: 1 },
      { name: "FISH FINGER", count: 1 },
      { name: "PUFF PUFF", count: 4 },
      { name: "MOSA", count: 4 },
      { name: "FANTAIL PRAWN", count: 1 },
    ],
  },
];
